// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.was-Invalidated-select[data-v-c0315b92] .v-select > div {\r\n  background-color: #f7d7da;\r\n  border: 1px solid #ff0018 !important;\n}\n[data-v-c0315b92] div.was-Invalidated {\r\n  border: none !important;\n}\n[data-v-c0315b92] .was-Invalidated.file-input-container {\r\n  border: 1px solid #ff0018 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
